import {
  CUSTOMERS_INFO_REQUEST, CUSTOMERS_INFO_UPDATE_REQUEST,
  CUSTOMERS_INFO_SUCCESS, CUSTOMERS_INFO_UPDATE_SUCCESS, CUSTOMERS_INFO_CLEAR,
  CUSTOMERS_INFO_SET_HEADER_TEXT, POPUP_NEW_ENTITY_SET_MASTER_PROFILE,
  CUSTOMERS_SET_LOGO_FILE,
  POPUP_ASSIGN_ENTITY_SAVE_TO_STORE
} from '../../constants/actionTypes';
import {ActionTypes} from "./AddNewEntityActions";

const initialState = {
  customerInfo: {},
  loading: false,
  updateSuccess: false,
  headerText: '',
  assignedMasterProfile: {},
  assignedFabricatorId: 0,
  assignedStoreId: 0,
  logoFile: null,
  __error__: null,
  subscriptions: [],
  assignedEntities: {}, // this will hold selected Fabricators or Stores chosen by the user when creating a new entity.
  showESignatureOverlay: false,
  showFingerSignatureOverlay: false,
  homeAdvisorApiEndpointUrl: ''
};

export default function newaccount(state = initialState, action) {
  switch (action.type) {
    case CUSTOMERS_INFO_REQUEST:
    case CUSTOMERS_INFO_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        updateSuccess: false
      };
    case CUSTOMERS_INFO_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSuccess: true,
        __error__: action.payload.__error__,
        assignedEntities: {}
      };
    case CUSTOMERS_INFO_SUCCESS:
      return {
        ...state,
        customerInfo: {
          ...action.customerInfo,
        },
        subscriptions: action.customerInfo.subscriptions || [],
        homeAdvisorApiEndpointUrl: action.customerInfo.homeAdvisorApiEndpointUrl,
        fabricatorSubscriptions: action.customerInfo.fabricatorSubscriptions || {},
        loading: false,
        updateSuccess: false,
        assignedEntities: {}
      };
    case CUSTOMERS_INFO_CLEAR:
      return {
        ...state,
        customerInfo: {},
        loading: false,
        updateSuccess: false
      };
    case ActionTypes.SET_SUBSCRIPTION_ID:
      return setSubscriptionId(state, action.payload);
    case CUSTOMERS_INFO_SET_HEADER_TEXT:
      return {
        ...state,
        headerText: action.headerText
      };
    case POPUP_NEW_ENTITY_SET_MASTER_PROFILE:
      return {...state, assignedMasterProfile: action.payload};
    case CUSTOMERS_SET_LOGO_FILE:
      return {...state, logoFile: action.payload};
    case POPUP_ASSIGN_ENTITY_SAVE_TO_STORE:
      return setAssignedEntities(state, action);
    case ActionTypes.SHOW_ESIGNATURE_OVERLAY:
      return {...state, showESignatureOverlay: action.payload.show};
    case ActionTypes.SHOW_FINGER_SIGNATURE_OVERLAY:
      return {...state, showFingerSignatureOverlay: action.payload.show};
    default:
      return state;
  }
}

function setAssignedEntities(state, {payload}) {
  const assignedEntities = state.assignedEntities;
  const {storePath} = payload;
  assignedEntities[storePath] = payload;
  return {...state, assignedEntities};
}

function setSubscriptionId(state, {type, sub}) {
  var newState = {...state};
  newState.fabricatorSubscriptions = newState.fabricatorSubscriptions || {};
  newState.fabricatorSubscriptions[type] = sub;
  return newState;
}
